var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'vertical')?_c('vertical-tab',{attrs:{"tabs":_vm.tabs,"icon":_vm.icon,"query-string":_vm.queryString}}):_c('horizontal-tab',{attrs:{"tabs":_vm.tabs,"query-string":_vm.queryString}})
}
var staticRenderFns = []

export { render, staticRenderFns }